<template>
  <div class="information">
    <el-card>
      <div slot="header" class="clearfix">
        <span>用户信息</span>
         <el-badge :is-dot="isShowBadge" style="float: right; padding: 3px 0; margin-left: 16px" class="badge">
           <el-button
              @click="open=true"
              v-if="path==='memberDetail'"
              :disabled="!isShowBadge"
              type="text"
              >查看档案图片</el-button
            >
        </el-badge>
        <el-button
          v-if="path==='memberDetail'"
          style="float: right; padding: 3px 0"
          type="text"
          @click="onCancel"
          >{{title}}</el-button
        >
      </div>
      <div>
        <el-tabs v-model="activeName" type="border-card" @tab-click="tabClick">
          <el-tab-pane
            class="content"
            :label="item.nodeName"
            v-for="item in memberEditData.children"
            :key="item.nodeName"
            :name="item.nodeCode"
          >
            <basicInformation
              :memberId="memberId"
              v-if="item.nodeName === '基本信息'"
              :storeList="storeList"
              :type="type"
              :memberEditData="memberEditData.memberInfo"
              :visitDetail="item.children"
              :id="id"
              :path="path"
              v-on="$listeners"
            ></basicInformation>
            <living-habit
              :type="type"
              :memberId="memberId"
              :visitDetail="item.children"
              v-else-if="item.nodeName === '生活习惯'"
              v-on="$listeners"
            ></living-habit>
          </el-tab-pane>
          <el-tab-pane name="treat" label="治疗历史" class="content">
            <treat-history :type="type" :list="memberTreatmentHistoryList" @success="success('Treatment')" :memberInfo="memberEditData.memberInfo" :memberId="memberId"></treat-history>
          </el-tab-pane>
          <el-tab-pane name="report" label="体检报告" class="content">
            <medicalExaminationReport :type="type" :list="memberMedicExaminationReportList" @success="success('Report')" :memberInfo="memberEditData.memberInfo" :memberId="memberId"></medicalExaminationReport>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
    <!-- 展示图片 -->
    <el-dialog title="查看图片" :visible.sync="open" width="500px">
      <el-image 
        style="width: 100px; height: 100px"
         v-for="(item,index) in imgs"
        :key="index"
        :src="item" 
        :preview-src-list="imgs">
      </el-image>
    </el-dialog>
  </div>
</template>
<script>
import basicInformation from "./formOfInformation/basicInformation.vue";
import livingHabit from "./formOfInformation/livingHabit.vue";
import treatHistory from "./formOfInformation/treatHistory.vue";
import medicalExaminationReport from "./formOfInformation/medicalExaminationReport.vue";
import {memberMedicExaminationReportListByMember, memberTreatmentHistoryListByMember} from '@/api/system/member'
import {memberArchiveDetail, listTreeWithConfig} from '@/api/system/member'
export default {
  components: {
    basicInformation,
    livingHabit,
    treatHistory,
    medicalExaminationReport
  },
  props: {
    path: {
      type: String,
      default() {
        return 'memberDetail'
      } 
    },
    type: {
      // 1 详情 2 编辑 3 新增
      default: 1,
      type: Number
    },
    storeList: {
      // 门店列表
      default(){
        return []
      },
      type: Array
    },
    id: {
      // 工单列表id
      default: null,
      type: Number
    },
    memberId: {
      type: Number,
      // required: true
      default() {
        return 0
      }
    }
  },
  watch: {
    type: {
      handler: function(val) {
        if(this.activeName === 'treat') {
        this.handleMemberTreatmentHistoryListByMember(this.memberId)
      }else if(this.activeName === 'report') {
        this.handleMemberMedicExaminationReportListByMember(this.memberId)
      }
      },
      immediate: true
    }
  },
  data() {
    return {
      open: false,
      loading: true,
      memberMedicExaminationReportList: [],
      memberTreatmentHistoryList: [],
      activeName: 'baseInfo',
      memberEditData: {}
    };
  },
  computed: {
    imgs() {
      if(this.memberEditData?.memberInfo?.archiveImgUrl) {
        return this.memberEditData?.memberInfo?.archiveImgUrl.split(',')
      }else {
        return []
      }
    },
    isShowBadge() {
      if(this.memberEditData?.memberInfo?.archiveImgUrl) {
        return true
      }else {
        return false
      }
    },
    title() {
      return this.type === 1? '编辑信息': '返回'
    }
  },
  created() {
    this.type !== 3 ?this.handleMemberArchiveDetail(this.memberId) : this.handleListTreeWithConfig()
  },
  methods: {
    // 获取用户档案信息
    handleMemberArchiveDetail(id) {
      memberArchiveDetail(id).then(res => {
        if(res.code === 200) {
           if(res.data) {
            this.memberEditData = res.data
          }else {
            this.handleListTreeWithConfig(id)
          }
        }
      })
    },
    // 获取用户档案树形配置表
    handleListTreeWithConfig(id) {
      listTreeWithConfig(id).then(res => {
        if(res.code === 200) {
          this.memberEditData  = {
            children: res.data
          }
        }
      })
    },
    success(type) {
      if(type === 'Treatment') {
        this.handleMemberTreatmentHistoryListByMember(this.memberId)
      }else {
        this.handleMemberMedicExaminationReportListByMember(this.memberId)
      }
    },
    // 获取治疗历史
    handleMemberTreatmentHistoryListByMember(id) {
      memberTreatmentHistoryListByMember(id).then(res => {
         if(res.code === 200) {
          this.memberTreatmentHistoryList = res.data
        }
      })
    },
    // 获取会员检查报告
    handleMemberMedicExaminationReportListByMember(id) {
      memberMedicExaminationReportListByMember(id).then(res => {
        if(res.code === 200) {
          this.memberMedicExaminationReportList = res.data
        }
      })
    },
    // tabs点击事件
    tabClick(val) {
      // console.log('val====>', val);
      if(val.label === '治疗历史') {
        this.handleMemberTreatmentHistoryListByMember(this.memberId)
      }else {
        this.handleMemberMedicExaminationReportListByMember(this.memberId)
      }
    },
    handleChange() {},
    onCancel() {
      this.$emit("handleEdit", this.type===1?2:1);
    },
    isActive(route) {
      return route.path === this.$route.path;
    },
  }
};
</script>
<style lang="less" scoped>
.badge ::v-deep .el-button {
  padding: 0;
}
.content ::v-deep .box-card {
  margin-bottom: 16px;
}
.btn {
  margin: 20px;
  width: calc(100% - 40px);
  text-align: center;
}
.content {
  height: 450px;
  // overflow: auto;
  /deep/ .el-scrollbar__wrap {
    overflow-x: hidden !important;
  }
}
.information /deep/ .el-collapse-item__header {
  background: #e6ebf5;
  padding-left: 10px;
  font-weight: bold;
}
.slot_title {
  display: flex;
  align-items: center;
  p:nth-child(1) {
    width: 4px;
    height: 22px;
    background: #46a6ff;
    border-radius: 6px;
    margin-right: 10px;
  }
}
.person_info {
  //   padding: 20px;
  //   padding-left: 50px;
  //   margin-bottom: 20px;
  .header {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    padding: 10px 4px;
    background: #e8f4ff;
    h4 {
      margin: 0;
      padding: 0;
      margin-right: 20px;
    }
  }
  h4 {
    // margin: 0;
    padding: 10px 4px;
    background: #e8f4ff;
    font-weight: normal;
  }
  .item {
    display: flex;
    // justify-content: space-between;
    width: 100%;
    align-items: center;

    p {
      width: 50%;
      font-size: 14px;
      //   padding-right: 100px;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      span:nth-child(1) {
        display: inline-block;
        width: 100px;
        text-align: left;
        /deep/ .el-tag--medium {
          margin-right: 10px;
        }
        // margin-right: 10px;
      }
      .require:before {
        content: "*";
        color: #f56c6c;
        margin-right: 4px;
      }
      /deep/ .el-input {
        width: 50%;
      }
    }
    .store {
      /deep/ .el-input {
        width: 100%;
      }
    }
    .remark {
      width: 100%;
    }
  }
}
.footer {
  padding: 20px;
  //   padding-left: 50px;
  .img {
    width: 100px;
    height: 100px;
    margin-right: 20px;
  }
}
.tip {
  color: #f56c6c;
  margin-left: 10px;
}
</style>
